export function isValidEmail(input: string) {
  if (input === '') return true;
  return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(input);
}

export function isNumeric(value: string) {
  return /^[0-9+]*$/.test(value);
}

export function isValidDate(dateString: string): boolean {
  const date = new Date(dateString);
  return !isNaN(date.getTime());
}

export function isValidPhoneNumber(value: string) {
  return /^[+]{1}[0-9]{7,}$/.test(value);
}
